module.exports = __webpack_public_path__ + "static/img/12.26099b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/1/zh/12.png
// module id = W5g4
// module chunks = 0